/**
 * Central feature flags (U19). Deliberately simple consts — one file, not a
 * framework. Stage-derived flags live here so a reviewer can see every gate
 * in one place; per-USER eligibility (groups) is `agents/agentAccess.ts`.
 */

import { isBeta, isProd } from './stage.ts';

/**
 * "Text my agents" SMS section in Account. Both deployed stages — each has
 * its own approved A2P toll-free registration (prod cleared 2026-07-29).
 * Hidden in local dev: the section would hit the real beta SMS backend and
 * send real texts.
 */
export const SMS_FEATURE_ENABLED: boolean = isBeta || isProd;

/**
 * Guest chat (subscription tiers T7/T8): the homepage dock + /guest console.
 * Beta-only while the guest experience is proven; prod builds hide the UI
 * entirely (the prod backend is deployed but dark).
 */
export const GUEST_CHAT_ENABLED: boolean = isBeta || isProd;

/**
 * Subscription tiers (T10): the real /pricing page with live checkout.
 * Beta-only until the prod launch bundle (guest + subscriptions + Vera
 * A2A ship together — see the prod-launch-bundle decision).
 */
export const SUBSCRIPTIONS_ENABLED: boolean = isBeta || isProd;

// (The former MCP_SETTINGS_ENABLED flag is gone: MCP-surface eligibility now
// delegates entirely to the agent registry via `canUseMcpSettings` →
// `isAgentEnabledFor('maximus', …)`, so stage + groups live in ONE place.)

/**
 * Ad placements (right-panel + chat-stream) — on only for the deployed stages
 * (beta + prod), never local dev. Per-user gating (guest + free only, never
 * paid) is layered on top in `agents/ads.ts`.
 *
 * NOTE: this enables the PLACEMENTS, not any particular vendor. No ad network
 * is currently wired in — `AdSlot` renders nothing until one is — so this
 * flag being true does not mean ads are served. See `components/AdSlot.tsx`.
 */
export const ADS_ENABLED: boolean = isBeta || isProd;

/**
 * Vera's stage gate is expressed in the agent registry itself
 * (`registry.ts vera.available = isBeta` + `requiredGroups`), not as a flag
 * here — eligibility is per-user, answered by `isAgentEnabledFor`. Listed
 * for discoverability.
 */
